import React, {useState, useEffect} from 'react';
import {ViewCardCarritoCompra} from './ViewCardCarritoCompra';
import {useSessionStore} from '../../hooks/useSessionStore';

export const CardCarritoCompra = (props) => {
	/* Destructuring the props object. */
	const {producto, onChangeComienzoCuidados, onChangeHorasSemana, borrarProducto} = props;

	/* Setting the state of the dropdown menu. */
	const [ComienzoCuidados, setComienzoCuidados] = useState(producto.ComienzoCuidados);
	const comienzoCuidadosDrop = [
		{label: '0', value: '0'},
		{label: '1', value: '1'},
		{label: '2', value: '2'},
		{label: '3', value: '3'},
		{label: '4', value: '4'},
		{label: '5', value: '5'},
		{label: '6', value: '6'},
		{label: '7', value: '7'},
	];
	const setComienzo = (event) => {
		onChangeComienzoCuidados(event.target.value, producto);
	};

	/* Setting the state of the dropdown menu. */
	const [HorasSemana, setHorasSemana] = useState();
	const horasSemanaDrop = [
		{label: '0', value: '0'},
		{label: '1', value: '1'},
		{label: '2', value: '2'},
		{label: '3', value: '3'},
		{label: '4', value: '4'},
		{label: '5', value: '5'},
		{label: '6', value: '6'},
		{label: '7', value: '7'},
		{label: '8', value: '8'},
	];
	const setHOras = (event) => {
		onChangeHorasSemana(event.target.value, producto);
	};

	/**
	 * It deletes the product from the cart.
	 */
	const borrarProductoCarrito = () => {
		borrarProducto(producto);
	};

	/* Setting the state of the dropdown menu. */
	useEffect(() => {
		setComienzoCuidados(producto.comienzoCuidados);
		setHorasSemana(producto.duracion);
	}, []);

	/* Passing the props to the ViewCardCarritoCompra component. */
	return (
		<ViewCardCarritoCompra
			producto={producto}
			borrarProductoCarrito={borrarProductoCarrito}
			comienzoCuidadosDrop={comienzoCuidadosDrop}
			ComienzoCuidados={ComienzoCuidados}
			setComienzo={setComienzo}
			horasSemanaDrop={horasSemanaDrop}
			HorasSemana={HorasSemana}
			setHOras={setHOras}
		/>
	);
};
